import {
  Home,
  Image,
  BookOpen,
  Bot,
  Music,
  SpellCheck2,
  ThumbsUp,
  Mic,
  Sparkles,
} from 'lucide-react';
import { NavbarConfig, SidebarConfig } from '../types/navigation.types';

export const sidebarConfig: SidebarConfig = {
  logo: {
    icon: '/logo.svg',
    iconBlack: '/logo-black.svg',
    text: 'KREAITOR',
  },
  menuItems: [
    {
      id: 'home',
      text: 'Home',
      icon: Home,
      path: '/',
      hasSubmenu: false,
    },

    {
      id: 'text-tools',
      text: 'Text Tools',
      icon: SpellCheck2,
      hasSubmenu: true,
      submenu: [
        {
          id: 'blog-writer',
          text: 'Blog Writer',
          path: '/ai-blog-writer/get-started',
        },
        {
          id: 'email-generator',
          text: 'Email Generator',
          path: '/email-generator/get-started',
        },
        {
          id: 'Chat-With-Docs',
          text: 'Chat-With-Docs',
          path: '/chat-with-docs/get-started',
        },
      ],
    },
    {
      id: 'image-tools',
      text: 'Image Tools',
      icon: Image,
      hasSubmenu: true,
      submenu: [
        {
          id: 'text-to-image',
          text: 'Text to Image',
          path: '/text-to-image/get-started',
        },
        {
          id: 'image-to-image',
          text: 'Image to Image',
          path: '/image-to-image/get-started',
        },
        {
          id: 'text-to-logo',
          text: 'Text to Logo',
          path: '/text-to-logo/get-started',
        },
        // {
        //   id: 'sticker-maker',
        //   text: 'Sticker-Maker',
        //   path: '/sticker-maker/get-started',
        // },
        {
          id: 'gif-maker',
          text: 'Gif-Maker',
          path: '/gif-maker/get-started',
        },
      ],
    },
    {
      id: 'audio-tools',
      text: 'Audio Tools',
      icon: Music,
      hasSubmenu: true,
      submenu: [
        {
          id: 'transcript-generator',
          text: 'Transcript Generator',
          path: '/transcript',
        },
        {
          id: 'text-to-speech',
          text: 'Text To Speech',
          path: '/text-to-speech/get-started',
        },
      ],
    },
    {
      id: 'gen-image-tools',
      text: 'Gen AI Tools',
      icon: Sparkles,
      hasSubmenu: true,
      submenu: [
        {
          id: 'upscale-image',
          text: 'Upscale Image',
          path: '/upscale-image/get-started',
        },
        {
          id: 'object-remover',
          text: 'Object Remover',
          path: '/object-remover/get-started',
        },
        {
          id: 'object-replacer',
          text: 'Object Replacer',
          path: '/object-replacer/get-started',
        },
      ],
    },
    {
      id: 'bot-builder',
      text: 'Multimedia Bot Builder',
      icon: Bot,
      path: '/bot-builder/',
      hasSubmenu: false,
    },
    {
      id: 'brand-book',
      text: 'Brandbook Generation',
      icon: BookOpen,
      path: '/brandbook/get-started',
      hasSubmenu: false,
    },
    {
      id: 'Podcast-writer',
      text: 'Podcast Generation',
      icon: Mic,
      path: '/ai-podcast-generator/get-started',
      hasSubmenu: false,
    },
    {
      id: 'social-media',
      text: 'Social Media Posts',
      icon: ThumbsUp,
      path: '/social-media/get-started',
      hasSubmenu: false,
    },
  ],
};

export const navbarConfig: NavbarConfig = {
  search: {
    enabled: true,
    placeholder: 'Search',
  },
  actions: [
    {
      id: 'theme-toggle',
      icon: 'Sun',
      type: 'theme',
    },
    {
      id: 'files',
      icon: 'Folders',
      type: 'icon',
      link: '/files',
    },
    {
      id: 'notifications',
      icon: 'Bell',
      type: 'icon',
    },
    {
      id: 'login',
      text: 'Login',
      type: 'button',
      variant: 'primary',
    },
  ],
};
